module.exports = __webpack_public_path__ + "img/delivery-platform-pc.4216c311.jpg";